import { Avatar } from './Avatar';

/**
 * Header no design ATUAL do WhatsApp (iOS 2025): claro e minimalista — fundo creme
 * translúcido com blur, nome escuro em destaque, e as ações de chamada agrupadas
 * numa única "pill" branca. Nada de faixa verde sólida (design antigo).
 */
export function ChatHeader({ onBack }: { onBack?: () => void }) {
  return (
    <header
      className="flex-shrink-0 z-10 bg-[#F7F3EC]/90 backdrop-blur-md border-b border-black/[0.06]"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="flex items-center px-1.5 sm:px-4 h-[56px] gap-1.5">
        {onBack && (
          <button
            type="button"
            aria-label="Voltar"
            onClick={onBack}
            className="w-9 h-10 flex items-center justify-center text-[#0A0A0A] active:opacity-50 transition-opacity flex-shrink-0"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        )}
        <Avatar size={38} />
        <div className="flex-1 min-w-0">
          <div className="text-[17px] sm:text-[15.5px] font-semibold text-[#0A0A0A] leading-[1.2] truncate tracking-[-0.01em]">
            Minas Brasil
          </div>
          <div className="text-[12px] leading-[1.25] text-[#1DAB61] font-medium">online</div>
        </div>

        {/* Ações agrupadas numa pill (vídeo + voz), como no WhatsApp novo */}
        <div className="flex items-center bg-white rounded-full border border-black/[0.06] shadow-[0_1px_2px_rgba(0,0,0,0.04)] px-1">
          <button
            type="button"
            aria-label="Chamada de vídeo"
            className="w-10 h-9 flex items-center justify-center text-[#0A0A0A] active:opacity-50 transition-opacity"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2.5" y="6.5" width="13" height="11" rx="3" />
              <path d="M15.5 10.5l5-3v9l-5-3" />
            </svg>
          </button>
          <div className="w-px h-5 bg-black/[0.08]" aria-hidden="true" />
          <button
            type="button"
            aria-label="Chamada de voz"
            className="w-10 h-9 flex items-center justify-center text-[#0A0A0A] active:opacity-50 transition-opacity"
          >
            <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
          </button>
        </div>

        <button
          type="button"
          aria-label="Mais opções"
          className="w-9 h-9 flex items-center justify-center rounded-full text-[#0A0A0A] active:opacity-50 transition-opacity"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <circle cx="12" cy="5" r="1.6" />
            <circle cx="12" cy="12" r="1.6" />
            <circle cx="12" cy="19" r="1.6" />
          </svg>
        </button>
      </div>
    </header>
  );
}
